import { useState, useEffect } from 'react'
import { useMsal } from '@azure/msal-react'
import { OIDC_DEFAULT_SCOPES } from '@azure/msal-browser'
import { ApiGateway } from '../config/config'
import axios from 'axios'

class RoleService {
  static #instanceRequest = false
  static #roleServiceInstance = undefined
  #queued = false

  constructor() {
    if (!RoleService.#instanceRequest) {
      throw new TypeError('Cannot be constructed. Please use RoleService.getInstance()')
    }
    RoleService.#instanceRequest = false
  }

  static getInstance() {
    if (! RoleService.#roleServiceInstance) {
      RoleService.#instanceRequest = true
      RoleService.#roleServiceInstance = new RoleService()
    }
    return RoleService.#roleServiceInstance
  }

  #getMaxPrivelege(roles) {
    const maxPrivelege = roles.reduce((p,c) => {
      if (!p || p.id > c.id) {
        return c
      }
      return p
    })
    return maxPrivelege
  }

  async getUserRole(msalInstance) {
    if (this.#queued) {
      return
    }
    this.#queued = true

    const account = msalInstance.getActiveAccount()
    const token = await msalInstance.acquireTokenSilent({
      scopes: OIDC_DEFAULT_SCOPES,
      account,
      forceRefresh: true
    })

    const koId = account.idTokenClaims.koId    

    const basePath = `${ApiGateway.profile}/${koId}`
    const options = {
      headers: {        
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token.idToken}`
      }
    }
    const response = await axios.get(basePath, options)
    console.log(response)
    let _role = undefined
    if (response.data) {
      _role = this.#getMaxPrivelege(response.data.roles)
    }
    this.#queued = false
    return _role
  }
}

export function useRole() {
  const { instance } = useMsal()
  const [role, setRole] = useState()

  function getRole() {
    return role
  }

  function getStorageKeyName() {
    const ds = new Date().toLocaleDateString()
    return btoa(ds)
  }
  function getRoleEncoded(rob) {
    const enc = btoa(JSON.stringify(rob))
    return enc
  }
  function getStoredRole() {
    const encodedRole = window.sessionStorage.getItem(getStorageKeyName())
    if (encodedRole == null) {
      return null
    }
    const dec = atob(encodedRole)
    const rob = JSON.parse(dec)
    return rob
  }
  function serializeRole(role_ob) {
    window.sessionStorage.setItem(getStorageKeyName(),getRoleEncoded(role_ob))
  }

  async function getAccountRole() {
    if (! role) {
      const storedRole = getStoredRole()
      if (storedRole != null) {
        setRole(storedRole)
        return
      } else {              
        const _role = await RoleService.getInstance().getUserRole(instance)        
        if (_role) {
          console.log(`setting role`, _role)
          setRole(_role)
          serializeRole(_role)
          return
        } else {
          setRole(undefined)
        }
      }
    }
  }

  const hasRole = (roles) => {
    let _roles
    if (Array.isArray(roles)) {
      _roles = roles
    } else if (typeof roles === 'object') {
      _roles = [roles]
    }
    return role && _roles.some((r) => r.id === role.id)
  }

  const ROLES = {
    ADMIN: {id: 1, name: 'Admin'},
    MFI_ADMIN: {id: 2, name: 'MFI Admin'},
    QSE_MGR: {id: 3, name: 'QSE Governance Manager'},
    BOTTLER: {id: 20, name: 'Bottler'}
  }
  
  const getRoleById = (id) => {
    return Object.values(ROLES).find(r => r.id === id)
  }

  const hasAnyRole = () => {
    return role && Object.values(ROLES).some((r) => r.id === role.id)
  }

  const cleanup = () => {
    sessionStorage.clear()
  }

  useEffect(() => {
    (async () => {
      await getAccountRole()
    })()
  })

  return {
    role,
    ROLES,
    getRole,
    hasRole,
    hasAnyRole,
    getRoleById,
    cleanup
  }
}